import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimWorkOrderStructureOperation } from 'pages/Project/BimProject/WorkOrder/types';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimRemoveWorkOrderChangeObjectGql } from '../workOrderChangeQueries';

export const useBimRemoveWorkOrderChangeObject = (
    operation?: BimWorkOrderStructureOperation,
    onSuccess?: () => void,
) => {
    const dispatch = useDispatch();

    const requestId = useMemo(() => `bimWorkOrderChange${operation || ''}`, [operation]);

    const [bimRemoveWorkOrderObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimRemoveWorkOrderObjectReset(undefined);
        onSuccess?.();
    }, [bimRemoveWorkOrderObjectReset, onSuccess]);

    const [
        bimRemoveWorkOrderChangeObjectData,
        bimRemoveWorkOrderChangeObjectStatus,
        bimRemoveWorkOrderChangeObjectError,
        bimRemoveWorkOrderChangeObjectRequest,
    ] = useRequest({
        requestId,
        query: bimRemoveWorkOrderChangeObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimRemoveWorkOrderObjectMakeChangeRequest = useCallback(
        (workOrderChangeId: number, contractObjectId: number) => {
            dispatch(bimRemoveWorkOrderChangeObjectRequest({ workOrderChangeId, contractObjectId }));
        },
        [bimRemoveWorkOrderChangeObjectRequest, dispatch],
    );

    useEffect(() => {
        bimRemoveWorkOrderObjectReset(undefined);
    }, [bimRemoveWorkOrderObjectReset]);

    return {
        bimRemoveWorkOrderChangeObjectData,
        bimRemoveWorkOrderChangeObjectStatus,
        bimRemoveWorkOrderChangeObjectError,
        bimRemoveWorkOrderObjectMakeChangeRequest,
    };
};
